<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    Edit Marketing Campaign
</h1>
<div mat-dialog-content>
    <app-marketing-campaign-form [form]="form" [groups]="groups"></app-marketing-campaign-form>
</div>
<div class="buttons" mat-dialog-actions>
    <button mat-raised-button [disabled]="!form?.valid" class="donebutton" color="primary" (click)="update()">OK</button>
    <button mat-button (click)="close()">Cancel</button>
</div>
